import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n.use(LanguageDetector).use(initReactI18next).init({
    debug: true,

    lng: localStorage.getItem("i18nextLng") || "ar",

    fallbackLng: "ar",
    supportedLngs: ["ar", "en"],
    resources: {
        en: {
            translation: {
                "pagination": {
                    "previous": "Previous",
                    "next": "Next"
                },
                "navbar": {
                    "home": "Home",
                    "services": "Services",
                    "projects": "Projects",
                    "resume": "Resume",
                    "testimonial": "Testimonial",
                    "contact": "Contact"
                },
                "banner": {
                    "welcomeMessage": "WELCOME TO MY WORLD",
                    "greeting": "Hi, I'm",
                    "myName": "Moayad Ismail",
                    "workAs": "a",
                    "titles": [
                        "Software Engineer.",
                        "Engineering Team Lead.",
                        "Technical Project Manager.",
                        "Full Stack Engineer.",
                        "SEO Specialist.",
                    ],
                    "description": "I'm ready to transform your ideas into digital reality by creating innovative software solutions and modern designs that reflect your vision and boost your sales. Whether you need a Mobile app, a professional website, a custom platform, or a fully integrated online store (E-commerce), I'm here to help you make it happen. Try it for yourself and see the difference!",
                    "findMe": "Find me in"
                },
                "features": {
                    "whatDo": "What i do",
                },
                "Projects": {
                    "feature": "Explore My Projects",
                    "title": "My Projects",
                },
                "resume": {
                    "feature": "1+ YEARS OF EXPERIENCE",
                    "title": "My Resume",
                    "skills": {
                        "title": "Professional Skills",
                    },
                    "experience": {
                        "title": "Experience",
                        "feature": {
                            "date": "2024 - 2025",
                            "title": 'Job Experience',
                        }
                    },
                    "education": {
                        "title": "Education",
                        "feature": {
                            "title": "Scientific And Academic Experience",
                            "date": "2023 - NOW",
                        }
                    }
                },
                "tesimonial": {
                    "feature": "what my client say",
                    "title": "Testimonial",
                },
                "contact": {
                    "feature": "CONTACT",
                    "title": "Contact With Me",
                    "box": {
                        "name": "MOAYAD SAMIR ISMAIL",
                        "job": "Developer",
                        "letBuild": "Let's Build Something Amazing Together!",
                        "wI_CanDo": "I'm passionate about transforming your vision into exceptional digital solutions. Whether you have a project in mind or need expert consultation, I'm here to help you every step of the way.",
                        "dontMiss": "Don't miss the opportunity, get in touch today for:",
                        "items": {
                            "item1": "Free consultation before starting the project to help you make the best decision",
                            "item2": "Custom digital solutions tailored precisely to your needs and goals",
                            "item3": "Continuous communication and daily reports to ensure full project transparency",
                            "item4": "Accurate delivery on time as promised",
                            "item5": "Competitive and fair pricing without compromising quality"
                        },
                        "phone": "phone",
                        "email": "Email",
                        "findMe": "OR FINT ME IN"
                    },
                    "form": {
                        "title": "Send a Message",
                        "name": "Name",
                        "phoneNumber": "Phone Number",
                        "email": "Email",
                        "subject": "Subject",
                        "message": "Message",
                        "sending" : "sending...",
                        "buttonText": "Send Now",
                        "errMessage": {
                            "userName": "Name field is required!",
                            "phoneNumber": "Phone number field is required!",
                            "email": "Please enter your email address!",
                            "emailVal": "Please enter a valid email address!",
                            "subject": "Please enter the subject you want to contact about!",
                            "message": "Message field is required!",
                            "Something": "Something went wrong. Please try again."
                        },
                        "successMessage": {
                            "leftMessage": "Thank you very much Mr./Ms.",
                            "rightMessage": "Your message has been sent successfully. We will get in touch with you."
                        }
                    }
                },
                "footer": {
                    "move": {
                        "title": "Move to",
                        "1": "Home",
                        "2": "services",
                        "3": "projects",
                        "4": "resume",
                        "5": "testimonial",
                        "6": "contact"
                    },
                    "servicesDetails": {
                        "title": "Services details",
                        "1": "Websites development",
                        "2": "Mobile App Development",
                        "3": "Admin dashboards",
                        "4": "SEO Optimisation",
                        "5": "Websites maintenance"
                    },
                    "projects": {
                        "title": "My Projects",
                        "1": "Aqariya News Website",
                        "2": "True Website",
                        "3": "Ouddess Store",
                        "4": "iPhone Store",
                        "5": "Admin Dashboard",
                        "6": "Kombucha Store",
                        "7": "Forever Store",
                    }

                }
            }
        },
        ar: {
            translation: {
                "pagination": {
                    "previous": "السابق",
                    "next": "التالي"
                },
                "navbar": {
                    "home": "الرئيسية",
                    "services": "خدماتي",
                    "projects": "مشاريعي",
                    "resume": "سيرة ذاتية",
                    "testimonial": "آراء العملاء",
                    "contact": "تواصل"
                },
                "banner": {
                    "welcomeMessage": "اهلاً بكم في عالمي",
                    "greeting": "مرحباً، انا",
                    "myName": "مؤيد اسماعيل",
                    "workAs": "أعمل ك",
                    "titles": [
                        "مهندس برمجيات.",
                        "مدير فرق هندسية.",
                        "مدير مشاريع تقنية.",
                        "Full Stack Engineer.",
                        "خبير في تحسين محركات البحث (SEO).",
                    ],
                    "description": "مستعد لتحويل أفكارك إلى واقع رقمي، من خلال صناعة حلول برمجية مبتكرة وتصاميم عصرية تعكس رؤيتك و تضاعف مبيعاتك. سواءً كنت بحاجة إلى تطبيق موبايل، أو موقع إلكتروني احترافي، أو منصة الكترونية مخصصة، أو متجر إلكتروني متكامل، فأنا هنا لمساعدتك على تحقيق ذلك. جرب بنفسك والمس الفرق!",
                    "findMe": "تجدني على المنصات :"
                },
                "features": {
                    "whatDo": "ماذا أقدم",
                },
                "Projects": {
                    "feature": "قم بزيارة مشاريعي",
                    "title": "مشاريعي",
                },
                "resume": {
                    "feature": "+1 سنة من الخبرة",
                    "title": "سيرتي الذاتية",
                    "skills": {
                        "title": "المهارات المهنية",
                        "items": {
                            "title1": "المهارات المنطقية و الاساسية",
                            "title2": "مهارات تقنية إضافية"
                        }
                    },
                    "experience": {
                        "title": "الخبرة",
                        "feature": {
                            "date": "2024 - 2026",
                            "title": 'الخبرة العملية',
                        }
                    },
                    "education": {
                        "title": "التعليم",
                        "feature": {
                            "title": "الخبرة العلمية و الأكاديمية",
                            "date": "2023 - الان",
                        }
                    }
                },
                "tesimonial": {
                    "feature": "ماذا يقول عملائي",
                    "title": "الشهادات",
                    "clients": {
                        "client1": {
                            "name": "هناء المنصوري",
                            "position": "دبي _ الإمارات العربية المتحدة",
                            "work": "رائد اعمال _ مؤسس شركة عصائر",
                            "service": "لوحة تحكم لإدارة المنتجات و الزبائن، و تحليل البيانات",
                            "from": "بداية العمل من ",
                            "fromDate": "24/12/2024",
                            "to": "إلى",
                            "toDate": "07/02/2025",
                            "rating": "5",
                            "text": "نظام رائع وسهل الاستخدام لإدارة البزنس حقي، شكرًا على اهتمامك وأتمنالك التوفيق",
                        }
                    },
                },
                "contact": {
                    "feature": "تواصل",
                    "title": "تواصل معي الان",
                    "box": {
                        "name": "مؤيد سمير اسماعيل",
                        "job": "مطور",
                        "letBuild": "دعنا نبني شيئا مذهلا معا!",
                        "wI_CanDo": "أنا شغوف بتحويل رؤيتك إلى حلول رقمية استثنائية. سواءً كان لديك مشروعٌ مُحدد أو كنت بحاجة إلى استشارة خبير، فأنا هنا لمساعدتك في كل خطوة.",
                        "dontMiss": "لا تفوت الفرصة، اتصل بي اليوم للحصول على:",
                        "items": {
                            "item1": "استشارة مجانية قبل بدء المشروع لمساعدتك في اتخاذ القرار الأفضل",
                            "item2": "حلول رقمية مصممة خصيصًا لتناسب احتياجاتك وأهدافك بدقة",
                            "item3": "تواصل مستمر وتقديم تقارير يومية لضمان سير المشروع بكل وضوح",
                            "item4": "تسليم دقيق في الوقت المحدد",
                            "item5": "أسعار مناسبة ومنافسة دون المساس بالجودة"
                        },
                        "phone": "هاتف",
                        "email": "إيميل",
                        "findMe": "أو تجدني على المنصات:"
                    },
                    "form": {
                        "title": "أرسل رسالة",
                        "name": "الاسم",
                        "phoneNumber": "رقم الهاتف",
                        "email": "الإيميل",
                        "subject": "الموضوع",
                        "message": "الرسالة",
                        "sending" : "جارِ الارسال",
                        "buttonText": "أرسل الان",
                        "errMessage": {
                            "userName": "حقل الاسم مطلوب!",
                            "phoneNumber": "حقل رقم الهاتف مطلوب!",
                            "email": "يرجى كتابة البريد الالكتروني الخاص بك!",
                            "emailVal": "يرجى كتابة بريد الكتروني صحيح!",
                            "subject": "يرجى كتابة الموضوع الذي تريد التواصل من اجله!",
                            "message": "حقل الرسالة مطلوب!",
                            "Something": "حدث خطأ ما. يُرجى المحاولة مرة أخرى."
                        },
                        "successMessage": {
                            "leftMessage": "شكراً جزيلاً سيد/ة",
                            "rightMessage": "تم ارسال رسالتك بنجاح و سنقوم بالتواصل معكم."
                        }
                    }
                },
                "footer": {
                    "move": {
                        "title": "الانتقال إلى",
                        "1": "الرئيسية",
                        "2": "الخدمات",
                        "3": "المشاريع",
                        "4": "السيرة الذاتية",
                        "5": "آراء العملاء",
                        "6": "اتصل بي"
                    },
                    "servicesDetails": {
                        "title": "تفاصيل الخدمات",
                        "1": "تطوير المواقع الإلكترونية",
                        "2": "متاجر إلكترونية",
                        "3": "لوحات تحكم للإدارة",
                        "4": "تحسين محركات البحث",
                        "5": "صيانة المواقع"
                    },
                    "projects": {
                        "title": "مشاريعي",
                        "1": "موقع العقارية نيوز",
                        "2": "موقع true",
                        "3": "متجر اوديس",
                        "4": "متجر ايفون",
                        "5": "لوحة تحكم ادارية",
                        "6": "متجر كومبوتشا",
                        "7": "متجر فوريفر"
                    }
                }
            }
        }
    },
    detection: {
        order: ["localStorage"],
        caches: ["localStorage"],
    },

    interpolation: {
        escapeValue: false,
    },
})